module.exports = __webpack_public_path__ + "img/fc-tip.52dd273c.png";